import $ from 'jquery';

export default function umeMenuInit() {
    const navbar = document.querySelector('header .navbar');
    const header = document.querySelector('header');
    let scrollHeight;
    const minificationBreakpoint = 90;

    let navbarCollapseBreakpoint = window.matchMedia("screen and (min-width: 1199px)");

    window.addEventListener('scroll', function () {
        const scrolledLogo = document.querySelector('.ume-primary-logo__scrolled');
        let globalTrue = scrolledLogo.classList.contains('ume-primary-logo__scrolled__global') ? true : false;
        const matches = navbarCollapseBreakpoint.matches ? navbarCollapseBreakpoint.matches : navbarCollapseBreakpoint.msMatchesSelector;

        if (matches && !globalTrue) {
            collapseNavbar(window.pageYOffset);
        }
    });


    function collapseNavbar(scrollY) {
        if (scrollY >= minificationBreakpoint && !navbar.classList.contains('minified')) {
            navbar.classList.add('minified');
            header.classList.add('minified');
        } else if (scrollY < minificationBreakpoint) {
            navbar.classList.remove('minified');
            header.classList.remove('minified');
        }
    }


    document.querySelector('.navbar-toggler').addEventListener('click', function () {
        this.classList.toggle('pressed');
    });
    $(function ($) {
        if ($(window).width() >= 1199) {

            $('.navbar .dropdown').hover(function () {
                $(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();

            }, function () {
                $(this).find('.dropdown-menu').first().stop(true, true).delay(100).slideUp();

            });
            $('.navbar .ume-sub-sub-holder').hover(function () {
                $(this).find('.dropdown-menu').first().stop(true, true).delay(50).slideDown();

            }, function () {
                $(this).find('.dropdown-menu').first().stop(true, true).delay(25).slideUp();

            });
            $('.navbar .dropdown  a').click(function () {
                location.href = this.href;
            });

        }


    });
    $(function ($) {
        if ($(window).width() < 1200) {
            const mainMenuList = document.getElementById('menu-hauptmenue');

            let parents = [];
            if (mainMenuList !== null){
                parents = mainMenuList.querySelectorAll('.menu-item-has-children');
            }

            if (parents.length > 0) {
                parents.forEach(parent => {
                    const link = parent.getElementsByTagName('a');
                    const dropdown = parent.querySelector('.dropdown-menu');
                    // sub top level parents
                    checkSubParents(dropdown);
                    if (link[0].getAttribute('href') === '#') return;
                    const newLink = link[0].cloneNode(true);
                    newLink.classList.add('ume-nav-mobile-new-link');
                    newLink.classList.remove('dropdown-toggle');
                    newLink.removeAttribute('data-toggle');
                    link[0].removeAttribute('data-toggle');
                    newLink.innerHTML = '';
                    const newDiv = document.createElement('div');
                    newDiv.classList.add('ume-nav-mobile-new-container');
                    newDiv.appendChild(link[0]);
                    newDiv.appendChild(newLink);
                    parent.insertBefore(newDiv, dropdown);
                    parent.addEventListener('click', ev => {
                        if (!ev.target.classList.contains('dropdown-toggle')) return;
                        ev.preventDefault();
                        dropdown.classList.toggle('d-block')
                    })


                })
            }


        }

    })
    function checkSubParents(parentElement){
        const subParents = parentElement.querySelectorAll('.ume-sub-sub-holder');
        if (subParents.length > 0){
            subParents.forEach(parent => {
                const link = parent.querySelector('.dropdown-item');
                const dropdown = parent.querySelector('.dropdown-menu');
                if (link.getAttribute('href') === '#') return;
                const newLink = link.cloneNode(link);
                newLink.classList.add('ume-nav-mobile-new-link');
                newLink.classList.remove('dropdown-item');
                link.classList.add('dropdown-item__active');
                newLink.removeAttribute('data-toggle');
                newLink.removeAttribute('aria-expanded');
                link.removeAttribute('data-toggle');
                link.removeAttribute('aria-expanded');
                newLink.innerHTML = '';
                const newDiv = document.createElement('div');
                newDiv.classList.add('ume-nav-mobile-new-container');
                newDiv.appendChild(link);
                newDiv.appendChild(newLink);
                parent.insertBefore(newDiv, dropdown);
                parent.addEventListener('click', ev => {
                    if (!ev.target.classList.contains('dropdown-item__active')) return;
                    ev.preventDefault();
                    dropdown.classList.toggle('d-block')
                })

            });
        }

    }
    /*
    document.addEventListener('click', (ev) => {

        if (!ev.target.matches('.navbar-toggler') && !ev.target.matches('.navbar-toggler-icon')) return;
        button = document.getElementById('sth-trigger-modal');

        button.classList.toggle('sth-trigger-modal-mobile-show');
    });*/
// Global Network Nav Toggle
    if (document.querySelector('.ume-global-menu')){
        if (document.querySelector('.ume-global-network')) {

            const button = document.querySelector('.ume-global-network');
            const link = button.querySelector('a');
            const primaryLogo = document.querySelector('.ume-primary-logo');
            const scrolledLogo = document.querySelector('.ume-primary-logo__scrolled');
            const secondaryLogo = document.querySelector('.ume-secondary-logo');
            const nav = document.querySelector('.ume-global-nav-content-wrapper');
            const randomLink = nav.querySelector('button');
            const menuList = document.querySelector('.ume-global-menu-list ');
            button.addEventListener('click', (ev) => {
                ev.preventDefault();
                link.classList.toggle('active');
                nav.classList.toggle('ume-global-nav-content-wrapper__show');
                primaryLogo.classList.toggle('d-none');
                if (secondaryLogo != null) {
                    secondaryLogo.classList.toggle('ume-hide');
                }
                scrolledLogo.classList.toggle('ume-primary-logo__scrolled__global');
                menuList.classList.toggle('ume-no-border');
                randomLink.focus();
            });



        }

        document.addEventListener('click', ev => {

            if (ev.target.parentNode.classList.contains('ume-global-alert')) {
                ev.preventDefault();
                $('#ume-info-modal').modal('show')

            }
            if (ev.target.parentNode.classList.contains('ume-global-international')) {
                ev.preventDefault();
                $('#ume-international-modal').modal('show')

            }
            if (ev.target.parentNode.classList.contains('ume-global-emergency')) {
                ev.preventDefault();
                $('#ume-notfall-modal').modal('show')

            }
            const matches = ev.target.matches ? ev.target.matches('.ume-global-network-close') : ev.target.msMatchesSelector('.ume-global-network-close');
            if (matches || ev.target.classList.contains('ume-global-network-close-icon')) {
                ev.preventDefault();
                const button = document.querySelector('.ume-global-network');
                button.click();
            } else return;


        })
    }

}




